import { v4 as uuidv4 } from 'uuid';

import { EVENT_CONFIGS } from 'mocks/server/utils/constants';

export type EventConfig = {
  type: 'Play' | 'Ad' | 'Skip' | 'Error' | 'Filler' | 'Sync';
  weight: number;
};

export type Event = {
  time: number;
  event: string;
  adId: string | null;
  spotTime: number | null;
};

const ONE_MINUTE_AS_MILLISECONDS = 60000;
const ONE_HUNDRED_PERCENT = 100;

const generateEvent = (currentTime: number, selectedEvent: EventConfig) => {
  const event = selectedEvent.type;
  const adId = event === 'Play' || event === 'Ad' ? uuidv4() : null;
  const spotTime = event === 'Play' || event === 'Ad' ? currentTime - 3600000 : null;

  return {
    time: currentTime,
    event,
    adId,
    spotTime,
  };
};

const getEventByWeighting = () => {
  const random = Math.random() * ONE_HUNDRED_PERCENT;
  let sum = 0;

  return EVENT_CONFIGS.find((event) => {
    sum += event.weight;
    return sum >= random;
  });
};

export const generateEvents = (from: Date, to: Date): Event[] => {
  const startTime = new Date(from).getTime();
  const endTime = new Date(to).getTime();

  const events: Event[] = [];
  let currentTime = startTime;

  while (currentTime <= endTime) {
    const selectedEvent = getEventByWeighting();
    if (selectedEvent) {
      events.push(generateEvent(currentTime, selectedEvent));
    }
    currentTime += ONE_MINUTE_AS_MILLISECONDS;
  }

  return events;
};
